import React from 'react';

import { Flex, Text } from '@opendoor/bricks/core';
import { ExternalLink } from 'platform/react-router';

/**
 * TODO: Add documentation
 * @deprecated This is a legacy component. Do not use.
 */
export const BrokerageDisclaimer: React.FC = () => (
  <Flex
    position="relative"
    flexBasis="100%"
    flexDirection="column"
    justifyContent="center"
    alignItems="flex-start"
    textAlign="left"
    bg="neutrals100"
    p={6}
  >
    <Text fontSize="s00" lineHeight="s000" color="neutrals0" mb={4}>
      An Opendoor home value estimate is not an appraisal.
    </Text>

    <Text fontSize="s00" lineHeight="s000" color="neutrals0" mb={4}>
      Licensed real estate services are provided by the Opendoor Brokerages. Data is provided for
      personal, not commercial use. All property information should be verified by the recipient and
      none is guaranteed as accurate.{' '}
      <ExternalLink
        analyticsName="brokerage-learn-more"
        href="https://www.opendoor.com/w/terms#brokerage_representation"
        aria-label="Navigate to learn more about brokerage representation"
      >
        Learn more
      </ExternalLink>
      .
    </Text>
  </Flex>
);
